import { NextRouter } from 'next/router';
import { IAttachmentWithName, IAttachmentWithUrl } from '@/creditflowresearch/domain/vo/ArticlesAndStats/IAttachment';
import { getCurrentPath, getQueryString, removeQueryParams } from '@framework/router';

export const formatAttachment = (attachment: IAttachmentWithUrl): IAttachmentWithName => ({
  ...attachment,
  name: attachment.displayName,
});

export enum UrlParamsToClear {
  statId = 'statId',
  articleId = 'articleId',
}

export const clearDownloadParams = (router: NextRouter, paramName: UrlParamsToClear) => {
  const { query, replace } = router;
  const newQuery = removeQueryParams(query, ['uploadId', 'displayName', 'download', paramName]);
  replace({
    pathname: getCurrentPath(router.asPath),
    query: getQueryString(newQuery),
  }, undefined, { shallow: true });
};
